import React, { lazy } from "react"

import { FrontendSpecificEntryPoint } from "./FrontendSpecificEntryPoint"
import { SharedContext } from "./shared/SharedContext"

const DevSwitcher = lazy(() => import("./DevSwitcher"))

export function EntryPoint() {
  return (
    <SharedContext>
      {__DEV__ ? <DevSwitcher /> : <FrontendSpecificEntryPoint />}
    </SharedContext>
  )
}
